export const PrivacyPolicyPage = () => {
  return (
    <section className="policy-page">
      <div class="container my-5">
            <h3 class="mb-4">Privacy Statement</h3>
            <p>We at Ciancio 1913 are pleased that you are visiting our website and thank you for your interest in our
                company, products and services. It is important to us that your privacy is protected whilst using our
                website.</p>
            <p>We collect, process and use personal data on our website under (www.uploads.ciancio.com) in accordance
                with
                the applicable data protection laws, including in particular the General Data Protection Regulation (EU)
                2016/679 (GDPR).</p>
            <h4>Controller</h4>
            <p>The data controller in relation to any personal data that is collected through this website is:</p>
            <ul class="mb-4">
                <li>Ciancio 1913 Co. Ltd</li>
                <li>Address: 149 - ‘Ciancio House’, Cannon Road, Zone 5, Central Business District, Qormi, CBD 5060,
                    Malta,
                    Europe</li>
                <li>Phone: <a href="tel:+35621480500">+356 21480500</a></li>
                <li>E-Mail: <a href="mailto:support@photociancio.com">support@photociancio.com</a></li>
                <li>Managing Director: Daniel De Bono</li>
            </ul>
            <h4>Our service</h4>
            <p>With this website we offer the service to transfer photos from your IT device to a stationary photo
                printing
                terminal. On the stationary photo printing terminal the photos can be printed.</p>
            <p>The photos you select will be uploaded to a cloud storage. After uploading the website provides a code.
                Such
                code allows you to transfer the photos to a stationary photo printing terminal. When entering the code
                in
                the relevant field of the stationary photo printing terminal the photos will be downloaded to the
                stationary
                photo printing terminal. You can then select specific photos and print them.</p>
            <p class="mb-4">When entering the code, you give your consent that the photos will be transferred to the
                stationary photo
                printing terminal. As operator of the stationary photo printing terminal, your photos are downloaded and
                stored in view of our privacy policy. Please click here for full details: (<a href="https://photociancio.com/privacy/">Photociancio Privacy Policy</a>)</p>
            <h4>Collection and processing of personal data</h4>
            <p>In principle you can visit and use our website without telling us who you are. We do not require any
                registration. Without further information from you we only collect and process certain technical
                information, including your Internet Protocol ("IP") address, time visited, pages visited and browser
                information. This information is only used for purposes of provision of our website. This data is also
                analysed for statistical and improvement purposes, whereby you remain anonymous as an individual user.
            </p>
            <p class="mb-4">When you use our service we collect photo data that you provide to us. We process and use
                the photo data for
                the provision of the service. When contacting us in case of an inquiry we use and process such
                information
                in order to respond to your enquiry. In addition we process your personal data based on your consent and
                (except for photo data) as necessary for the purpose of our legitimate interests, including to customize
                and
                improve our digital offerings, products and service and for market research purposes (Art. 6 (1) (a),
                (b)
                and (f) GDPR).</p>
            <h4>Data transfer to perform our service</h4>
            <p class="mb-4">We share your data with affiliated Ciancio 1913 companies if necessary for the provision of
                the service. For
                the performance of this service, we can employ a third party that performs the service on our behalf and
                transfer data necessary for any such service to the third party. Such third party will be subject to
                strict
                contractual obligations to comply with our instructions and applicable data protection laws as our
                processor.</p>
            <h4>Retention period</h4>
            <p class="mb-4">Images uploaded to our cloud storage will be stored for a maximum of six hours and will be
                deleted
                thereafter. With respect to the storage of your photos on the local terminal please see to our retention
                policy here: (<a href="https://photociancio.com/privacy/">Photociancio Privacy Policy</a>).</p>
            <h4>Data transfer in case of enquiries</h4>
            <p class="mb-4">Information you provide together with an enquiry (except for photos) we share with
                affiliated Ciancio 1913
                companies if this is necessary to respond to your enquiries. We may forward enquiries regarding our
                products
                and services also to a distributor that is responsible for the relevant product or service category and
                region.</p>
            <h4>Transfer to authorities</h4>
            <p class="mb-4">Any transfer of your personal data to authorities will only occur in accordance with
                mandatory laws.</p>
            <h4>Data Security</h4>
            <p class="mb-4">Ciancio 1913 takes adequate technical and organizational security measures in order to
                protect your personal
                data from being misused and to prevent the loss of your data. Your personal data is saved in a secure
                operating environment that is not accessible to the public.</p>
            <h4>Further information and contacts, information, corrections, blocking and deletion.</h4>
            <p>You can contact us using the following contact information:</p>
            <ul class="mb-4">
                <li>Address: 149 - ‘Ciancio House’, Cannon Road, Zone 5, Central Business District, Qormi, CBD 5060,
                    Malta,
                    Europe</li>
                <li>Phone: <a href="tel:+35621480500">+356 21480500</a></li>
                <li>E-Mail: <a href="mailto:support@photociancio.com">support@photociancio.com</a></li>
            </ul>
            <p>You have the right to lodge a complaint with a competent supervisory authority in accordance with the
                GDPR
                and applicable laws if you consider that the processing of personal data relating to you infringes GDPR.
                For
                this purpose, you can contact in particular the supervisory authority in Malta.</p>
            <p>Ciancio 1913 reserves the right to change, amend, or update this privacy statement. If we do decide to
                change
                our privacy statement, we will post the revised privacy statement. On return visits to our site, please
                remember to review the privacy statement for any changes, since continued use of our site after any
                posted
                revision indicates your consent to our use your information in accordance with the changed, amended, or
                updated privacy statement.</p>

        </div>
    </section>
  );
}

